import { render, staticRenderFns } from "./ClientEmailEdit.vue?vue&type=template&id=3f92c802&scoped=true"
import script from "./ClientEmailEdit.vue?vue&type=script&lang=js"
export * from "./ClientEmailEdit.vue?vue&type=script&lang=js"
import style0 from "./ClientEmailEdit.vue?vue&type=style&index=0&id=3f92c802&prod&lang=css"
import style1 from "./ClientEmailEdit.vue?vue&type=style&index=1&id=3f92c802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f92c802",
  null
  
)

export default component.exports